module.exports = __webpack_public_path__ + "static/media/mat-transition-left.bebb27b5.png";